import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // This forces the window to scroll to the very top (x: 0, y: 0)
    window.scrollTo({
  top: 0,
  left: 0,
  behavior: "smooth", // Creates a high-end, elegant transition
});
  }, [pathname]); // Fires every time the URL path changes

  return null;
}